import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  site: yup.string().required('Customer site is a required field'),
  items: yup
    .array()
    .of(
      yup.object().shape({
        date: yup
          .date()
          .typeError('Pickup date is required')
          .required('Pickup date is required'),
        eventName: yup.string().max(255),
        notes: yup.string().max(1000),
        isFinalPickup: yup.boolean(),
      }),
    )
    .min(1, 'Add at least one pickup')
    .max(10, 'You can create up to 10 pickups at a time'),
});
